// @flow
import { UPDATE_LOCATIONS } from '../actions/locations/basicCreators';

export default function locations(state: Array<any> = [], action: Object) {
  switch (action.type) {
    case UPDATE_LOCATIONS:
      return action.locations;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/locations.js